import { Slot } from "@suse-o11y/slot";
import React from "react";

import { HiddenTooltipProvider, useIsTooltipHidden } from "./context";

const TooltipTrigger = React.lazy(async () => {
	const Tooltip = await import("@radix-ui/react-tooltip");

	return { default: Tooltip.Trigger };
});

export type TriggerProps = React.ComponentPropsWithoutRef<typeof TooltipTrigger>;

export const Trigger = React.forwardRef<React.ComponentRef<typeof TooltipTrigger>, TriggerProps>(
	({ asChild, ...props }, ref) => {
		const hidden = useIsTooltipHidden();

		const node = asChild ? <Slot ref={ref} {...props} /> : <button ref={ref} type="button" {...props} />;

		if (hidden) {
			return node;
		}

		return (
			<React.Suspense fallback={node}>
				{/* Disable nested tooltips */}
				<HiddenTooltipProvider value>
					{asChild ? (
						<TooltipTrigger asChild {...props} ref={ref} />
					) : (
						<TooltipTrigger asChild>
							{/* For some reason the default TooltipTrigger does not assign type="button" */}
							{node}
						</TooltipTrigger>
					)}
				</HiddenTooltipProvider>
			</React.Suspense>
		);
	},
);

Trigger.displayName = "Tooltip.Trigger";
